import { Typography, Button, } from '@material-ui/core'
import React, { ChangeEvent, Dispatch, ReactNode } from 'react'
import { useActiveUser } from '../hooks/useActiveUser'
import OrganizationDetails from './OrganizationDetails'
import Organizations from './Organizations'

export default function Home() {
  const activeUser = useActiveUser()

  if (activeUser.organization)
    return <OrganizationDetails organizationId={activeUser.organization.externalId} />
  else
    return <Organizations />
}